import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import { AxiosResponse } from "axios";
import { HttpStatusCode } from "@/api-datastores/http-status.enum";
import { BadRequestError } from "@/models/http-errors.model";
import $http from "../api-datastores/http";
import { handleError } from "./shared";

/** Get cities by prefecture for evacuation-centers */
export async function getEvacuationCitiesByPrefecture(
  prefectureName: string,
  mapsMapType: string,
): Promise<PortalAdapterApi.ResponseGetTopArea> {
  try {
    const response: AxiosResponse = await $http.get(`/v1/evacuation-centers/prefectures/${prefectureName}/cities`, {
      params: { mapsMapType, unixtime: Date.now() / 1000 },
    });
    if (response.status !== HttpStatusCode.OK) {
      throw new BadRequestError(`response error: ${response.status}`);
    }
    return response.data;
  } catch (error: any) {
    return handleError(error);
  }
}
